import Chart from 'react-apexcharts'

const defaultFormatter = val => {
  return val + '%'
}

const defaultLegend = {
  position: 'bottom',
  horizontalAlign: 'center',
}

const BarChartWrapper = ({
  data,
  categories,
  width,
  colors,
  stacked = true,
  formatter = defaultFormatter,
  legend = defaultLegend,
  yProps,
  dataLabelsProps,
}) => {
  const options = {
    chart: {
      foreColor: '#666E7B',
      type: 'bar',
      stacked,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    dataLabels: {
      formatter,
      style: {
        fontSize: '18px',
      },
      background: {
        enabled: true,
        foreColor: '#666E7B',
        padding: 4,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: '#fff',
        opacity: 0.8,
      },
      ...dataLabelsProps,
    },
    xaxis: {
      categories,
      labels: {
        show: true,
        style: {
          colors: [],
          fontSize: '16px',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    colors,
    yaxis: {
      labels: {
        show: true,
        style: {
          fontSize: '16px',
          fontWeight: 600,
        },
        formatter,
      },
      ...yProps,
    },
    legend,
  }

  return (
    <Chart
      options={options}
      series={data}
      type='bar'
      height='90%'
      width={width}
    />
  )
}

export default BarChartWrapper
